"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayError = void 0;

// ValidationFormField's default shouldDisplayError triggers every time a field is dirtied,
// which means an error displays the moment a user starts typing. We only want errors
// to start/continue showing after the user has hit submit.
//
// To do this we override shouldDisplayError to check if the field is touched instead of dirtied,
// and set touchOnBlur on our form to false. When the form is submitted, redux-form marks
// all fields as touched, which triggers error display.
//
// See: https://github.com/erikras/redux-form/issues/733#issuecomment-195935723
var shouldDisplayError = function shouldDisplayError(_ref) {
  var error = _ref.error,
      submitFailed = _ref.submitFailed,
      touched = _ref.touched;
  return !!error && (submitFailed || touched);
};

exports.shouldDisplayError = shouldDisplayError;
//# sourceMappingURL=shouldDisplayError.js.map